(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Media', Media);


    /* @ngInject */
    function Media($resource) {
        var resourceUrl = 'api/media/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'cloudupload': {
                url: 'api/media/cloudupload/:type',
                method: 'POST',
                isArray: false
            },
        });
    }
})();
